module.exports = __webpack_public_path__ + "static/media/aditya_rastogi.2e3d1030.jpg";